import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';

const CategoryGrid = ({ rowData, fetchStockData, canEditMaster, setSelectedRow, handleEdit }) => {

    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 45 },
        { headerName: 'Record ID', field: 'id',  headerCheckboxSelectionFilteredOnly: true, suppressMovable: true,minWidth: 550 },
        { headerName: 'Category', field: 'description', headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, minWidth: 550 },
        {
            headerName: 'Status', field: 'exp3', cellRenderer: BtnCellRenderer, minWidth: 460,headerCheckboxSelectionFilteredOnly: true, suppressMovable: true,
            cellRendererParams: {
                canEditMaster: canEditMaster,
                handleEdit: handleEdit,
                clicked: function (field, isActive) {
                    updateActiveStatus(field, isActive);
                },
            },
        }
    ];
    const updateActiveStatus = async (id, isActive) => {
        try {
            const apiService = new ApiService();
            
            let body = {
                id: id,
                exp3: isActive === "1" ? "1" : "0"
            }
            const res = await apiService.put(`UPDATE_WAREHOUSE_CAT_MASTER`, body);
            if (res?.status === 200) {
                console.log('Updated successfully');
                fetchStockData();
            } else {
                console.error('Failed to update');
            }
        } catch (error) {
            console.error('Error updating item:', error);
        }
    };
    const onCellClicked = (event) => {
        if (event.colDef.field === 'id') {
            setSelectedRow(null);
            const clickedRowData = event.data;
            setSelectedRow(clickedRowData);
            handleEdit(clickedRowData)
        }
    };
    const onSelectionChanged = (event) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
    };
    return (
        <div className='brdor' style={{ height: 550 }}>
            <div className="ag-theme-quartz" style={{ height: 550 }}>
                <AgGridReact
                    getRowStyle={(params) => {
                        return params.node.rowIndex % 2 === 0
                            ? { background: '#F0EDF5' }
                            : { background: '#fff' };
                    }}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onSelectionChanged={onSelectionChanged}
                    onCellClicked={onCellClicked}
                />
            </div>
        </div>
    );
};

class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
    }

    btnClickedHandler() {
        const { value, clicked, data } = this.props;
        const exp3 = data.exp3 === "1" ? "0" : "1";
        clicked(data?.id, exp3);
    }
    render() {
        const { exp3 } = this.props.data;
        const { canEditMaster } = this.props;
        return (
            <div className='d-flex gap-3'>
                {canEditMaster === true ?
                    <div className="form-check form-switch center">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={`flexSwitchCheck`}
                            checked={exp3 === "1"}
                            onClick={this.btnClickedHandler}
                        />
                    </div>
                    :
                    <div className="form-check form-switch center">
                        <input disabled
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={`flexSwitchCheck`}
                            checked={exp3 === "1"}
                        />
                    </div>
                }
            </div>
        )
    }
}
export default CategoryGrid;
